export enum ReportSingleValueCardLabels {
  STARTING_VALUE = "Starting Value",
  CURRENT_VALUE = "Current Value",
  CUMULATIVE_CALL_INCOME = "Call Income (Period)",
  NET_REALIZED_TLH_LOSSES = "Net Realized TLH Losses",
  OVERLAY_VS_STOCK_ALONE = "Overlay vs Stock Alone",
  OVERLAY_RETURN_TWR = "Overlay Return TWR",
}

export enum ReportSingleValueCardDescriptions {
  STARTING_VALUE = "Beginning balance",
  CURRENT_VALUE = "Current Value of the stock portfolio",
  CUMULATIVE_CALL_INCOME = "Call Income (Period)",
  NET_REALIZED_TLH_LOSSES = "Net Realized TLH Losses generated since inception",
  OVERLAY_VS_STOCK_ALONE = "Return of option overlay only",
  OVERLAY_RETURN_TWR = "Return of Stock + Overlay",
}

export enum ReportTheamedValueCardLabels {
  KEEP_YOUR_SHARES = "Keep your shares",
  GENERATE_INCOME = "Generate Income",
  HARVEST_TAX_BENEFITS = "Harvest Tax Benefits",
}

export enum ReportTheamedValueCardDescriptions {
  KEEP_YOUR_SHARES = "",
  GENERATE_INCOME = "Covered calls seek to add a steady income stream, with the trade-off that some upside may be capped.",
  HARVEST_TAX_BENEFITS = "Tax-loss harvesting seeks to create a pool of capital losses to help offset gains. Figures are estimates.",
}

export enum ReportTheamedValueCardValuesLabels {
  STARTING_SHARES = "Starting Shares", // Keep your shares
  CURRENT_SHARES = "Current Shares", // Keep your shares
  STOCK_PRICE_START = "Stock Price (Start)", // Keep your shares
  STOCK_PRICE_NOW = "Stock Price (Now)", // Keep your shares
  STOCK_ONLY_RETURN = "Stock-Only Return", // Keep your shares
  UPSIDE_PARTICIPATION = "Participation rate", // Generate Income
  OPTION_INCOME_PERIOD = "Option Income (Period)", // Generate Income
  DIVIDEND_INCOME_PERIOD = "Dividend Income", // Generate Income
  CUMULATIVE_INCOME = "Cumulative Income", // Generate Income
  AVG_ANNUALIZED_YIELD = "Period Option Yield", // Generate Income
  CURRENT_OPTION_BUYBACK = "Current Option Buyback", // Generate Income
  NET_OPTION_INCOME = "Net Income", // Generate Income
  NET_REALIZED_LOSSES = "Net Realized Losses", // Harvest Tax Benefits
  LOSSES_USED = "Losses Used", // Harvest Tax Benefits
  LOSSES_REMAINING = "Losses Remaining", // Harvest Tax Benefits
  SHARES_SOLD = "Shares Sold", // Harvest Tax Benefits
  SELLABLE_TODAY = "Sellable Today", // Harvest Tax Benefits
}

export enum StrategyReportSingleValueCardLabels {
  STARTING_VALUE = "Starting Value",
  // card and pdf payload use different strings
  ENDING_VALUE_CARD = "Ending value",
  ENDING_VALUE_PDF = "Ending Value",
  NET_CHANGE = "Net Change",
  TIME_WEIGHTED_RETURN_CARD = "Time-Wgt Return*",
  TIME_WEIGHTED_RETURN_PDF = "Time-Wgt Return",
  INCOME_RECEIVED = "Income Received",
  MARGIN_INTEREST = "Margin Interest",
}

export enum StrategyReportSingleValueCardDescriptions {
  STARTING_VALUE = "Beginning balance",
  ENDING_VALUE = "Ending balance",
  NET_CHANGE = "Absolute change",
  TIME_WEIGHTED_RETURN = "Net of fees",
  INCOME_RECEIVED = "Divs & Option Premium",
  MARGIN_INTEREST = "Cost of borrowing",
}

export enum StrategyReportThemedCardLabels {
  KEEP = "Keep",
  PROTECT = "Protect",
  DIVERSIFY = "Diversify",
  HARVEST = "Harvest",
}

export enum StrategyReportThemedCardDescriptions {
  KEEP = "keep",
  PROTECT = "protect",
  DIVERSIFY = "diversify",
  HARVEST = "harvest",
}

export enum StrategyReportThemedCardValuesLabels {
  SHARES_START = "Shares (Start)", // Keep
  SHARES_END = "Shares (End)", // Keep
  VALUE_START = "Value (Start)", // Keep
  VALUE_END = "Value (End)", // Keep
  DIVIDENDS = "Dividends", // Keep
  PARTICIPATION_RATE = "Participation Rate", // Keep
  BASIS = "Basis", // Keep
  TAX_SAVINGS = "Tax Savings", // Keep
  MAX_STOCK_DROP = "Max Stock Drop", // Protect
  OEA_DROP = "OEA Drop", // Protect
  COLLAR_PL = "Collar P&L", // Protect
  AVAILABLE_MARGIN_BALANCE = "Available Margin Balance", // Protect
  OVERALL_DIVERSIFIED_PERFORMANCE = "Overall Diversified Performance", // Diversify
  TAX_LOSS_HARVEST_SLEEVE = "Tax-Loss Harvest Sleeve", // Diversify
  BEGINNING_CONCENTRATION = "Beginning Concentration", // Diversify
  CURRENT_CONCENTRATION = "Current Concentration", // Diversify
  HOLDINGS = "Holdings", // Diversify
  REALIZED_LOSSES = "Realized Losses", // Harvest
  LOSSES_USED = "Losses Used", // Harvest
  POOL_REMAINING = "Pool Remaining", // Harvest
  UNREALIZED_GAINS = "Unrealized Gains", // Harvest
  SHARES_SOLD = "Shares Sold", // Harvest
  SELLABLE_TODAY = "Sellable Today", // Harvest
}

// The Keep card switch's first option
export const KEEP_TOTAL_OPTION = "Total";

export enum StrategyReportThemedCardBlurbs {
  KEEP = "You remained an owner of your stock while the OEA structure managed risk and tax opportunities.",
  PROTECT = "Collars aim to reduce impact of severe declines but also limit upside during rallies.",
  DIVERSIFY = "Gradually reducing reliance on single stock by introducing diversified return sources.",
  HARVEST = "Tax figures are estimates only. Please review with your tax advisor.",
}
